import { FC, useState } from "react";
import { Box, LinearProgress, Typography } from "@mui/material";
import styles from "./ProgressSteps.module.scss";

interface IProgressSteps {
    stepsInfo: string[],
    currentStep: number
}

const ProgressSteps: FC<IProgressSteps> = (props): JSX.Element => {
    const { stepsInfo, currentStep } = props;
    const progress = (): number => {
        return Math.ceil(((currentStep + 1) / stepsInfo.length) * 100);
    }
    return (
        <>
            <Box className={styles.progressWrap}>
                {stepsInfo.map((step, index) => {
                    return (
                        <Box key={index} className={`${styles.progressStep} ${index <= currentStep ? styles.active : ''}`}>
                            <Typography className={styles.stepName} variant="subtitle1" component="p">{step}</Typography>
                        </Box>
                    )
                })}
            </Box>
            <Box className={`${styles.customProgress} mg-t-16`}>
                <LinearProgress color="error" variant="determinate" value={progress()} />
            </Box>
        </>
    )
}

export default ProgressSteps;